import { Card, Row, Col } from "antd"

// Components
import SVG from "../../../../../v3/components/SVG"

// Service library
import { TIME } from "../../../../../v3/services/util"

import { report_handler } from "../../../../../v3/handlers"

const {
    speedSelector
} = report_handler

const InfoCard = ({
    vehicle
}) => {

    const transitStatus = vehicle?.transitStatus?.toLowerCase()

    return (
        <Card
            style={{
                width: '80vw',
                alignSelf: 'center',
                margin: '1vh auto',
            }}
        >
            <Row justify={'space-between'}>
                <Col><b>{vehicle.plate}</b></Col>
                <Col>
                    {
                        transitStatus
                        &&
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <SVG 
                                viewBox="0 0 14 14" 
                                fill="none" 
                                size="20"
                                name={`${transitStatus}-square`}
                            />
                            <span style={{ color: '#878787' }}>
                                {transitStatus?.toLowerCase().replace(/^\w/, (c) => c.toUpperCase())}
                                ({`${transitStatus === 'moving' ? ( speedSelector(vehicle, 'STATE').toFixed(1) ) || '0.0' : "0.0"} km/h`})
                            </span>
                        </div>
                    }
                </Col>
            </Row>
            <div style={{ margin: '15px 0'}}>
                {vehicle.address || '-'}
            </div>

            <div style={{ color: '#878787'}}>
                Updated at {TIME.dayjsDatetimeTranslate(vehicle.vehicleTime || vehicle.deviceTime)}
            </div>
        </Card>
    )
}

export default InfoCard